import type {CapacityCombined} from '@/types/CapacityCombined';
import type {CapacityLabel} from '@/types/CapacityLabel';

const buildCapacityDefaultTotals = (
    yearMonthsDisplay : string[],
    lockedLabels : CapacityLabel[],
    capacityCombined : CapacityCombined[],
) : Record<string, number> => {
    const defaultSums : Record<string, number> = {};

    for (let i = 0; i < yearMonthsDisplay.length; i++) {
        const fiscalMonth = yearMonthsDisplay[i];

        if (!defaultSums[fiscalMonth]) {
            defaultSums[fiscalMonth] = 0;
        }

        for (const lockedLabel of lockedLabels) {
            const foundCombined = capacityCombined
                .find(combined => combined.timeLabelID === lockedLabel.timeLabelID);

            defaultSums[fiscalMonth] += foundCombined ? (foundCombined.hours[i] ?? 0) : 0;
        }
    }

    return defaultSums;
};

export default buildCapacityDefaultTotals;
